import { render } from "./Agent.vue?vue&type=template&id=4e6c4247&scoped=true"
import script from "./Agent.vue?vue&type=script&lang=js"
export * from "./Agent.vue?vue&type=script&lang=js"

import "./Agent.vue?vue&type=style&index=0&id=4e6c4247&lang=scss&scoped=true"

import exportComponent from "D:\\ideaWorkSpace\\政泉\\zhengquan\\sqlpj-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e6c4247"]])

export default __exports__